import Section from './Section';
import './About.css';

function About() {
  return (
    <Section name="about" title="About" tone="base">
      {/* TODO(Adam): swap this placeholder for your real story */}
      <div className="about">
        <p>
          I'm Adam - the human behind the Smallphish. I've spent my career
          helping teams ship software that people can actually trust:
          leading engineering teams across fintech, banking, and SaaS - from PSD2 and Transaction Monitoring at
          Deutsche Bank, to scaling large amount payments and building anti-scam protections at Wise, to platform engineering at Monday.com and 10x Banking.
        </p>
        <p>
          My happy place lies where product meets engineering - pragmatism. I care about
          getting the fundamentals right. Clarity, simplicity and sensible
          architecture - letting us ship quickly, and iterate fast.
          When I'm not shipping stuff, you can find me travelling, cooking, or playing with my dog.
        </p>
      </div>
    </Section>
  );
}

export default About;
